import { getSession, setSession } from './store.js';

const LOCK_DURATION = 30000;
const LOCK_STORAGE_KEY = 'kefir_lk_login_lock';

function getLockState() {
    try {
        const raw = sessionStorage.getItem(LOCK_STORAGE_KEY);
        return raw ? JSON.parse(raw) : { attempts: 0, lockUntil: 0 };
    } catch (e) {
        return { attempts: 0, lockUntil: 0 };
    }
}

function setLockState(state) {
    try {
        sessionStorage.setItem(LOCK_STORAGE_KEY, JSON.stringify(state));
    } catch (e) { /* ignore */ }
}

function shake(el) {
    el.classList.remove('auth--shake');
    // eslint-disable-next-line no-unused-expressions
    el.offsetWidth;
    el.classList.add('auth--shake');
}

export function initAuth({ onSuccess }) {
    const screen = document.querySelector('#auth-screen');
    if (!screen) return;

    const form = screen.querySelector('#auth-form');
    const forgotForm = screen.querySelector('#forgot-form');
    const loginInput = screen.querySelector('#auth-login');
    const passwordInput = screen.querySelector('#auth-password');
    const loginField = screen.querySelector('#auth-field-login');
    const passwordField = screen.querySelector('#auth-field-password');
    const errorEl = screen.querySelector('#auth-error');
    const submitBtn = screen.querySelector('#auth-submit');
    const rememberInput = screen.querySelector('#auth-remember');
    const toggleBtn = screen.querySelector('#auth-password-toggle');
    const forgotLink = screen.querySelector('#auth-forgot');
    const forgotBack = screen.querySelector('#forgot-back');
    const forgotEmail = screen.querySelector('#forgot-email');
    const forgotError = screen.querySelector('#forgot-error');
    const forgotSuccess = screen.querySelector('#forgot-success');

    function showError(message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
        shake(screen.querySelector('.auth__form-wrap'));
    }

    function clearError() {
        errorEl.hidden = true;
        loginField.classList.remove('auth__field--error');
        passwordField.classList.remove('auth__field--error');
    }

    toggleBtn.addEventListener('click', () => {
        const isPassword = passwordInput.type === 'password';
        passwordInput.type = isPassword ? 'text' : 'password';
        toggleBtn.textContent = isPassword ? 'Скрыть' : 'Показать';
        toggleBtn.setAttribute('aria-label', isPassword ? 'Скрыть пароль' : 'Показать пароль');
    });

    forgotLink.addEventListener('click', () => {
        form.hidden = true;
        forgotForm.hidden = false;
        forgotEmail.focus();
    });

    forgotBack.addEventListener('click', () => {
        forgotForm.hidden = true;
        form.hidden = false;
        forgotError.hidden = true;
        forgotSuccess.hidden = true;
        forgotForm.reset();
        loginInput.focus();
    });

    forgotForm.addEventListener('submit', e => {
        e.preventDefault();
        const email = forgotEmail.value.trim();
        const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        forgotError.hidden = true;
        forgotSuccess.hidden = true;

        if (!validEmail) {
            forgotError.textContent = 'Введите корректный email';
            forgotError.hidden = false;
            return;
        }

        forgotSuccess.textContent = `Если адрес ${email} привязан к кабинету, ссылка для смены пароля придёт в течение 5 минут. Проверьте папку «Спам».`;
        forgotSuccess.hidden = false;
    });

    function updateLockMessage() {
        const lock = getLockState();
        if (lock.lockUntil > Date.now()) {
            const secondsLeft = Math.ceil((lock.lockUntil - Date.now()) / 1000);
            showError(`Слишком много попыток. Попробуйте через ${secondsLeft} с`);
            submitBtn.disabled = true;
            const interval = setInterval(() => {
                const remaining = Math.ceil((lock.lockUntil - Date.now()) / 1000);
                if (remaining <= 0) {
                    clearInterval(interval);
                    submitBtn.disabled = false;
                    clearError();
                } else {
                    errorEl.textContent = `Слишком много попыток. Попробуйте через ${remaining} с`;
                }
            }, 1000);
            return true;
        }
        return false;
    }

    updateLockMessage();

    form.addEventListener('submit', e => {
        e.preventDefault();
        clearError();

        const lock = getLockState();
        if (lock.lockUntil > Date.now()) {
            updateLockMessage();
            return;
        }

        const login = loginInput.value.trim();
        const password = passwordInput.value.trim();

        if (!login && !password) {
            loginField.classList.add('auth__field--error');
            passwordField.classList.add('auth__field--error');
            showError('Введите логин и пароль');
            return;
        }
        if (!login) {
            loginField.classList.add('auth__field--error');
            showError('Введите логин');
            return;
        }
        if (!password) {
            passwordField.classList.add('auth__field--error');
            showError('Введите пароль');
            return;
        }

        const isValid = login.toLowerCase() === 'demo' && password.toLowerCase() === 'demo';

        submitBtn.disabled = true;
        submitBtn.textContent = 'Входим…';

        setTimeout(() => {
            if (isValid) {
                setLockState({ attempts: 0, lockUntil: 0 });
                setSession(rememberInput.checked);
                onSuccess();
            } else {
                const attempts = lock.attempts + 1;
                submitBtn.disabled = false;
                submitBtn.textContent = 'Войти';
                passwordInput.value = '';

                if (attempts >= 5) {
                    setLockState({ attempts: 0, lockUntil: Date.now() + LOCK_DURATION });
                    updateLockMessage();
                } else {
                    setLockState({ attempts, lockUntil: 0 });
                    loginField.classList.add('auth__field--error');
                    passwordField.classList.add('auth__field--error');
                    showError('Неверный логин или пароль');
                    passwordInput.focus();
                }
            }
        }, 600 + Math.random() * 400);
    });

    const session = getSession();
    if (session && session.loggedIn) {
        onSuccess();
    }
}

export function renderAuthScreen() {
    document.querySelector('#auth-screen').hidden = false;
    document.querySelector('#cabinet-app').hidden = true;
}
